import { render, staticRenderFns } from "./ContractAnnexes.vue?vue&type=template&id=db321ccc"
import script from "./ContractAnnexes.vue?vue&type=script&lang=js"
export * from "./ContractAnnexes.vue?vue&type=script&lang=js"
import style0 from "./ContractAnnexes.vue?vue&type=style&index=0&id=db321ccc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports